var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column screen-control-planning-table__status-cell",
    },
    [
      _c("kh-icon", {
        attrs: { color: _vm.statusColor, icon: _vm.statusIcon },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }